// extracted by mini-css-extract-plugin
module.exports = {"AdvancedCommunicationsPage":"AdvancedCommunicationsPage_AdvancedCommunicationsPage__2gF6k","advCommPanelContainer":"AdvancedCommunicationsPage_advCommPanelContainer__292jj"};